<template>
    <div class="flex flex-col justify-center items-center min-h-screen">
        <img src="@/assets/Next_logo.svg" class="mb-5">
        <h2 class="font-bold text-xl">401</h2>
        <p>Non puoi visualizzare questa pagina</p>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'PermissionDenied',
    components: {
    },
})
export default class PermissionDenied extends Vue {
}
</script>


<style lang="scss">
</style>
